import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from "jquery";

class NavigationBar extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
  	}

  	handleClick(event)
  	{
  		$('.navbar-collapse').removeClass("show");
  	}

	render() {
    	return (
	    		<div className="container" id="nav">
					<nav className="navbar sticky-top navbar-expand-lg navbar-light text-center">			
					  	<a className="navbar-brand" href="/"><img src="images/kanzlei-heckmann-logo.jpg" className="img-fluid" alt="Logo"></img></a>

					  	<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					    	<span className="navbar-toggler-icon"></span>
					  	</button>

					  	<div className="collapse navbar-collapse paddingTop45px" id="navbarSupportedContent">
					    	<ul className="navbar-nav mr-auto">
					      		<li className="nav-item active" onClick={this.handleClick.bind(this)}>
					        		<Link to="/" className="nav-link">HOME</Link> 
					      		</li>
					      		<li className="nav-item active" onClick={this.handleClick.bind(this)}>
					        		<Link to="/diekanzlei" className="nav-link">DIE KANZLEI</Link> 
					      		</li>
					      		<li className="nav-item active" onClick={this.handleClick.bind(this)}>
					        		<Link to="/leistungen" className="nav-link">LEISTUNGEN</Link> 
					      		</li>
					      		<li className="nav-item active" onClick={this.handleClick.bind(this)}>
					        		<Link to="/kontakt" className="nav-link">KONTAKT</Link> 
					      		</li>
					    	</ul>
					  	</div>
					</nav>
				</div>
    	);
  	}
}

export default NavigationBar;


// WEBPACK FOOTER //
// ./src/NavigationBar.js